import { render, staticRenderFns } from "./DiscussionBoardNewPosts.vue?vue&type=template&id=aa734422&"
import script from "./DiscussionBoardNewPosts.vue?vue&type=script&lang=js&"
export * from "./DiscussionBoardNewPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports